import React, { useEffect } from "react";
import { ScrollToTop } from "../components/ScrollToTop";

const ReturnRefundPolicy = () => {
  useEffect(() => {
    
  });

  return (
    <div className="max-w-4xl mx-auto px-4 py-8 bg-white">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          RETURN & REFUND POLICY
        </h1>
        <p className="text-gray-600">Updated at August 30th, 2024</p>
      </header>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Definitions and key terms
        </h2>

        <p className="mb-4 text-gray-700">
          To help explain things as clearly as possible in this Return &amp;
          Refund Policy, every time any of these terms are referenced, they are
          strictly defined as:
        </p>
        <ul>
          <li>
            <strong>Company:</strong> Refers to “Sairah A venture of Soradis
            Group under Soradis Jewellers Private Limited”.
          </li>
          <li>
            <strong>Customer:</strong> Refers to anyone who signs up to use the
            service.
          </li>
          <li>
            <strong>Device:</strong> Any internet-connected device (phone,
            tablet, computer).
          </li>
          <li>
            <strong>Service:</strong> The service provided by the company as
            described in the terms.
          </li>
          <li>
            <strong>Website:</strong>{" "}
            <a
              href="https://www.sairahjewels.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.sairahjewels.com
            </a>
          </li>
          <li>
            <strong>You:</strong> A person or entity registered to use the
            Services.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Return & Refund Policy
        </h2>
        <p className="mb-4 text-gray-700">
          Thanks for shopping at Sairah A venture of Soradis Group under Soradis
          Jewellers Private Limited. We appreciate the fact that you like to buy
          the stuff we build. We also want to make sure you have a rewarding
          experience while you’re exploring, evaluating, and purchasing our
          products.
        </p>
        <p className="mb-4 text-gray-700">
          As with any shopping experience, there are terms and conditions that
          apply to transactions at Sairah A venture of Soradis Group under
          Soradis Jewellers Private Limited. We’ll be as brief as our attorneys
          will allow. The main thing to remember is that by placing an order or
          making a purchase at Sairah A venture of Soradis Group under Soradis
          Jewellers Private Limited, you agree to the terms set forth below
          along with Sairah A venture of Soradis Group under Soradis Jewellers
          Private Limited’s Privacy Policy.
        </p>
        <p className="mb-4 text-gray-700">
          If there’s something wrong with the you bought, or if you are not
          happy with it, you will not be able to issue a refund for your item.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Refunds</h2>
        <p className="mb-4 text-gray-700">
          We at Sairah A venture of Soradis Group under Soradis Jewellers
          Private Limited commit ourselves to serving our customers with the
          best products. Every single product that you choose is thoroughly
          inspected, checked for defects and packaged with utmost care. We do
          this to ensure that you fall in love with our products.
        </p>
        <p className="mb-4 text-gray-700">
          Sadly, there are times when we may not have the product(s) that you
          choose in stock, or may face some issues with our inventory and
          quality check. In such cases, we may have to cancel your order. You
          will be intimated about it in advance so that you don't have to worry
          unnecessarily about your order. If you have purchased via Online
          payment (not Cash on Delivery), then you will be refunded once our
          team confirms your request.
        </p>
        <p className="mb-4 text-gray-700">
          We carry out thorough quality check before processing the ordered
          item. We take utmost care while packing the product. At the same time
          we ensure that the packing is good such that the items won’t get
          damaged during transit. Please note that Sairah A venture of Soradis
          Group under Soradis Jewellers Private Limited is not liable for
          damages that are caused to the items during transit or transportation.
        </p>
        <p className="mb-4 text-gray-700">
          We follow certain policies to ensure transparency, efficiency and
          quality customer care:
        </p>

        <ul>
          <li>
            • We accept returns only if there's an issue with the plating of the
            jewellery. Our 90-day warranty policy specifically covers
            plating-related problems. Other concerns are not covered under this
            warranty.
          </li>
          <li>
            • Customers have a 90-day window from the date of delivery to raise
            a warranty claim. The "Claim Warranty" button in the Orders section
            will be available during this period and becomes inactive once the
            window expires.
          </li>
          <li>
            • Once a warranty claim is submitted and the item is returned, our
            quality control team inspects the jewellery. If the issue is
            confirmed to be plating damage (e.g., tarnish or corrosion), we will
            repair the piece and send it back at no cost to the customer. We
            also cover the shipping both to and from our manufacturing unit.
          </li>
          <li>
            • If inspection reveals that the plating damage was due to improper
            handling (such as contact with soap, handwash, shower gel, or
            chemicals), we will not repair or replace the item. Instead, we
            return it to the customer, who must cover the round-trip shipping
            cost. The customer will receive shipping instructions from our
            support team. Once proof of payment is emailed to{" "}
            <a href="mailto:support@sairahjewels.com">
              support@sairahjewels.com
            </a>
            , the item will be shipped to the address linked to the customer's
            Sairah account. If the shipping cost is not paid, we will hold the
            item at our facility without liability.
          </li>
          <li>
            • Decisions regarding the resale of used items are made at the
            discretion of our quality control team on a case-by-case basis.
            Regardless, we always strive to deliver products of the highest
            quality to our customers.
          </li>
        </ul>
        <p>For International Orders:</p>
        <p>
          We follow certain policies to ensure transparency, efficiency and
          quality customer care:
        </p>
        <ul>
          <li>
            • Returns are accepted only when there is a confirmed issue with the
            jewellery’s plating. Our 90-day warranty policy exclusively covers
            plating defects. No other concerns are included under this warranty.
          </li>
          <li>
            • Customers have a 90-day window from the delivery date to raise a
            warranty claim. A “Claim Warranty” button will be available in the
            Orders section during this period and will be deactivated once the
            90 days have passed.
          </li>
          <li>
            • If a warranty claim is submitted and the product is returned, our
            quality control team will thoroughly inspect it. If the plating is
            found to be tarnished or corroded, we will repair the item and ship
            it back at no cost to the customer. Both the pickup and redelivery
            shipping charges will be covered by us.
          </li>
          <li>
            • If damage is found to be caused by improper handling—such as
            exposure to soap, handwash, shower gel, or chemicals—the warranty
            will be void. In such cases, the jewellery will be returned without
            repair, and the customer will bear the full cost of two-way
            shipping. Our support team will communicate the shipping charges.
            Once proof of payment is emailed to{" "}
            <a href="mailto:support@sairahjewels.com">
              support@sairahjewels.com
            </a>
            , the item will be dispatched to the address linked to the
            customer’s Sairah account. If the shipping fee is not paid, we will
            retain the item with no further obligation or liability.
          </li>
          <li>
            • Each product is eligible for a warranty claim only once, provided
            the claim is approved by our team.
          </li>
          <li>
            • The resale of returned or used products is determined by our
            quality control team on a case-by-case basis. However, we always
            ensure that customers receive the highest quality items.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Your Consent
        </h2>
        <p className="mb-4 text-gray-700">
          By using our website, registering an account, or making a purchase,
          you hereby consent to our Return & Refund Policy and agree to its
          terms.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Changes To Our Return & Refund Policy
        </h2>
        <p className="mb-4 text-gray-700">
          Should we update, amend or make any changes to this document so that
          they accurately reflect our Service and policies. Unless otherwise
          required by law, those changes will be prominently posted here. Then,
          if you continue to use the Service, you will be bound by the updated
          Return & Refund Policy. If you do not want to agree to this or any
          updated Return & Refund Policy, you can delete your account.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Contact Us
        </h2>
        <p>
          If you’re not satisfied, contact us:
          <br />• Email:{" "}
          <a href="mailto:support@sairahjewels.com">support@sairahjewels.com</a>
          <br />• Phone:{` `} <a href="tel:8828826996">+91 88288 26996</a>
        </p>
      </section>
    </div>
  );
};

export default ReturnRefundPolicy;
